import { useEffect, useState } from "react";

const navLinks = [
  { label: "新片速递", href: "#new" },
  { label: "编辑精选", href: "#curated" },
  { label: "口碑热榜", href: "#rank" },
  { label: "影评专栏", href: "#review" },
  { label: "题材片库", href: "#genre" },
  { label: "观影指南", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed inset-x-0 top-0 z-50 transition-all duration-300 " +
        (scrolled ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-200))]" : "bg-transparent")
      }
    >
      <div className="container-x flex h-16 items-center justify-between gap-4 md:h-20">
        <a
          href="#top"
          className="flex shrink-0 items-center gap-2.5"
          onClick={() => setOpen(false)}
          aria-label="吃瓜影院 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-600 text-white">
            <i className="ri-film-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className={"font-heading text-lg md:text-xl font-black " + (scrolled ? "text-foreground-950" : "text-white")}>
              吃瓜影院
            </span>
            <span className={"mt-0.5 text-[10px] tracking-[0.2em] " + (scrolled ? "text-primary-600" : "text-white/70")}>
              选片 · 观影指南
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={
                "rounded-full px-3.5 py-2 text-sm font-medium whitespace-nowrap transition-colors " +
                (scrolled
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                  : "text-white/85 hover:bg-white/10 hover:text-white")
              }
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className={
              "hidden whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors sm:inline-flex " +
              (scrolled ? "bg-primary-600 text-white hover:bg-primary-700" : "bg-white text-primary-700 hover:bg-primary-50")
            }
          >
            联系我们
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className={
              "flex h-10 w-10 items-center justify-center rounded-full lg:hidden " +
              (scrolled ? "text-foreground-900 hover:bg-background-100" : "text-white hover:bg-white/10")
            }
          >
            <i className={"text-xl " + (open ? "ri-close-line" : "ri-menu-line")} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      <div
        className={
          "overflow-hidden transition-[max-height,opacity] duration-300 lg:hidden " +
          (open ? "max-h-[560px] opacity-100" : "max-h-0 opacity-0")
        }
      >
        <nav className="container-x flex flex-col gap-1 border-t border-background-200 bg-background-50 px-4 py-3" aria-label="移动端导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="rounded-xl px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-1 inline-flex items-center justify-center rounded-xl bg-primary-600 px-3 py-2.5 text-sm font-semibold text-white"
          >
            联系我们
          </a>
        </nav>
      </div>
    </header>
  );
}